<div class="icon" [class]="classes">
  <i-tabler *ngIf="icon" [name]="icon"></i-tabler>
  <img *ngIf="imgIcon" [src]="imgIcon" />
</div>
